import { factory } from "../../../utils/apiThunkFactory";

export const getMapSettings = factory.get("MapDisplay/getMapSettings", "/api/maps/settings");
export const getLockedRooms = factory.get("MapDisplay/getLockedRooms", "/api/rooms/locked");
export const getAllRoomsData = factory.get("MapDisplay/getAllRoomsData", "/api/rooms/room-data");
export const roomsIdHaveEvent = factory.get("MapDisplay/roomsIdHaveEvent", "/api/bookings/get-bookings-room-id");
export const getMeetingsByRoomId = factory.get("MapDisplay/getBookingsByRoomId", "/api/bookings/getByRoom/:roomId");
export const getMaps = factory.get("MapDisplay/getMaps", "/api/maps/all/:user_id");
export const changeMap = factory.post(
  "MapDisplay/changeMap",
  "/api/placement/map",
);
export const getMapsByTenant = factory.get("MapDisplay/getMapsByTenant", "/api/maps/all-maps-by-tenant");
export const virerUser = factory.post("MapDisplay/virerUser", "/api/placement/kick_user/:email");

export const getRoomsWithReception = factory.post("MapDisplay/getRoomsWithReception", "/api/rooms/list-reception");

export const updateMapName = factory.post("MapDisplay/updateMapName", "/api/maps/update_name_map");